<div class="let-modal">
 <!-- Change Number block start-->
 <div *ngIf="isChangeNumberFlow">
  <div class="modal-header hdr-bt-0">
    <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkChNum}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="success-issues-block">
      <div class="success-issues-report">
        <div class="m-b-10">
          <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
          <span>{{validChangeNumberLines.length}}
            {{authoringContentData?.bulkFlow?.itemsUploadedSuccessfullyText}}</span>
        </div>
        <div *ngIf="linesWithError.length>0">
          <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
          <span>{{linesWithError.length}} {{authoringContentData?.bulkFlow?.issuesFound}}</span>
        </div>
      </div>
      <div class="success-issues-download">
        <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
        <div *ngIf="linesWithError.length >= 13">
          <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
            <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
            {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
          </a>
        </div>
      </div>
      <hr>
      <div *ngIf="bulkUploadFailedFlag && isChangeNumberFlow && linesWithError.length < 13">
        <mat-accordion *ngFor="let line of tempLineWithError;let i = index">
          <mat-expansion-panel [expanded]="manageLineService.step === i"
            (closed)="expansionPanelClosed(line)" (opened)="expansionPanelOpened(line)">
            <mat-expansion-panel-header class="specific-class" (click)="manageLineService.setStep(i)">
              <mat-panel-title class="accordion-txt">
                <span [ngClass]="(line.success) ? 'succes_validator' : 'error_complete'"></span>
                {{line?.PhoneNumber}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small-normal-black ">
              <div class="row ">

                <div class="col-12  col-sm-6 mb-3">
                  <form class="example-form" [ngClass]="{'change-number-acc': line.Reason_For_Change==''}">

                    <mat-form-field class="w100">
                      <mat-select placeholder="{{authoringContentData?.changeNumberAuthoring?.reasonForChange}}"
                        [formControl]="changeReasonForm" required [(ngModel)]="line.Reason_For_Change"
                        (selectionChange)="validateChangeReason(line)" name='reasonCodes'>
                        <mat-option *ngFor="let reason of msisdnChangeReasons" [value]="reason.description">
                          {{reason.description}}
                        </mat-option>

                      </mat-select>
                      <span  class="npaErrorMsg small-text d-flex text-danger" *ngIf="line.Reason_For_Change==''"  >
                        <strong>{{authoringContentData?.changeNumberAuthoring?.reasonForChangeError}}</strong>
                      </span>
                    </mat-form-field>
                  </form>

                </div>
                <div class="col-12  mb-3">
                  <form class="example-form" [ngClass]="{'change-number-acc': line.Preferred_Area_Code==''}">
                    <mat-form-field class="example-full-width">
                      <input matInput
                        placeholder="{{authoringContentData?.changeNumberAuthoring?.preferredAreaCodeTxt}}" required
                        (blur)="validateZipcode(line,$event)" [(ngModel)]="line.Preferred_Area_Code"
                        [ngModelOptions]="{standalone: true}" [maxLength]="'3'">
                      <span  class="npaErrorMsg small-text d-flex text-danger" *ngIf="line.invalid_area_code"  >
                        <strong>{{authoringContentData?.changeNumberAuthoring?.areaCodeError}}</strong>
                      </span>
                    </mat-form-field>


                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-4 mt-3">
                  <button type="button" class="col-12 primary_btn"
                    (click)="manageLineService.nextStep(); expansionPanelClosed(line);"
                    [disabled]="line.errorValidator">{{authoringContentData?.manageLineRestore?.nextTxt}}</button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
        </mat-accordion>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row col-12 pl-0">
      <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
        <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
          [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.changeNumber">
          {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
        </button>
      </div>
      <div class="col-12 col-md-6 agre-line d-flex">
        <div>
          <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox  || ((validChangeNumberLines.length)<=0) "></mat-checkbox>
        </div>
        <div class="acceptanceText pl-2">
          <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxt}}</span>
        </div>
      </div>
    </div>
    <div class="row col-12 pl-0 pt-3">
      <div class="col-12 pl-0">
        <p class="small m-b-10 font-bold">{{authoringContentData?.changeNumberAuthoring?.changingMultipleMsisdnMsg}}</p>
        <p class="m-b-5 font-bold small">{{authoringContentData?.changeNumberAuthoring?.advisements}}</p>
        <p class="legal"> {{authoringContentData?.changeNumberAuthoring?.bulkAdvisementMsg}}</p>
      </div>
    </div>
  </div>
</div>
<!-- Change Number block Ends-->

 <!-- Suspend block start-->
  <div *ngIf="isSuspendFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkSuspenLines}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithErrorDuplicate?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length >= 13">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>
        <div *ngIf="linesWithError.length < 13">
          <mat-accordion *ngFor="let line of linesWithError;let i = index">
            <mat-expansion-panel [expanded]="line.expendFlagValue" (closed)="expansionPanelClosed(line)"
              (opened)="expansionPanelOpened(line)">
              <mat-expansion-panel-header class="specific-class" (click)="manageLineService.setStep(i)">
                <mat-panel-title class="accordion-txt">
                  <span class="succes_validator" *ngIf="line.succesValidator"></span>
                  <span class="error_complete" *ngIf="line.errorValidator"></span>
                  {{line?.msisdn}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="small-normal-black">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="custom-ddl-wrapper nopadding-left">
                          <mat-form-field class="w100 " [ngClass]="{'clr-red': line.reasoneCodeValidation}">
                            <mat-select placeholder="{{authoringContentData?.manageLine?.reasonForChange}}"
                              [formControl]="line.reasonForChange">
                              <mat-option *ngFor="let reason of reasons" [value]="reason.description"
                                (click)="onChangeSuspendReasonForMultiple(line, reason)">
                                {{reason.description}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div *ngIf="line.reasoneCodeValidation" class="displayErrorInlineReason">
                            {{authoringContentData?.bulkFlow?.reasonErrTxt}}
                          </div>
                          <div *ngIf="resonErrorInline" class="displayErrorInlineReason">
                            {{resonErrorInline}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6" *ngIf="line.reasonForChanges && line.approverType && !line.isSeasonal
                && !line.isstolen">
                    <div *ngIf="line?.reasonForChanges?.code !== ssqConstant">
                      <div class="row">
                        <div class="col-12">
                          <div class="custom-ddl-wrapper nopadding-left">
                            <mat-form-field class="w100">
                              <mat-select placeholder="{{authoringContentData?.suspend?.approverType}}"
                                [formControl]="line.lineApproverType">
                                <mat-option *ngFor="let aproverType of line.approverTypeList"
                                  [value]="aproverType.description"
                                  (click)="line.startDate = ''; line.endDate = '';line.succesValidator = false;selectsubmitCheckBox = false;tncCheckBox = true;changeApproverTypeForMultiple(line, aproverType)">
                                  {{aproverType.description}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                          </div>
                          <div *ngIf="line.aproverErrorInline" class="displayErrorInline">
                            {{line.aproverErrorInline}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row"
                  *ngIf="line.reasonForChanges && (line.approverType || line.isSeasonal) && !line.isstolen">
                  <div class="col-12 col-sm-6 col-md-6 mt-3">
                    <div class="label_box pr9">
                      <div class="date_label">
                        <div class="datepic_box">
                          <input type="text" readonly="readonly" class="datepicker" name="dp"
                            [(ngModel)]="line.startDate" ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle()"
                            [minDate]="minimumDate" [maxDate]="line.maxStartDate"
                            (ngModelChange)="line.endDate = '';line.succesValidator = false;selectsubmitCheckBox = false;tncCheckBox = true;"
                            (dateSelect)="multipleStartDateSelected(line)"
                            [ngStyle]="{'color': (line.suspendStartDateValidation) ? 'red' : ''}" />

                          <label id="temporary-start_date_label start-date-position"
                            [ngStyle]="{'color': (line.suspendStartDateValidation) ? 'red' : ''}"
                            [ngClass]="{'floating-label-hasvalue-date': line.startDate}">{{authoringContentData?.manageLine?.startDate}}*</label>
                          <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                          <span class="far fa-calendar-alt "></span>
                        </div>
                        <div *ngIf="line.suspendStartDateValidation" class="displayErrorInline">
                          <span>{{authoringContentData?.bulkFlow?.starDateErrTxt}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 mt-3" id="temporary-end_date_div">
                    <div class="label_box pr1">
                      <div class="date_label">
                        <div class="datepic_box ">
                          <input type="text" readonly="readonly" class="datepicker" name="dp" [(ngModel)]="line.endDate"
                            ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" [disabled]="!line.startDate"
                            (dateSelect)="multipleEndDateSelected(line)"
                            [ngClass]="{'endDateClaenderDisable': !line.startDate}" [minDate]="line.minimumEndDate"
                            [maxDate]="line.maxDate"
                            [ngStyle]="{'color': (line.restoreDateValidation && !line.suspendStartDateValidation) ? 'red' : ''}" />
                          <label id="temporary-end_date_label start-date-position"
                            [ngClass]="{'floating-label-hasvalue-date': line.endDate}"
                            [ngStyle]="{'color': (line.restoreDateValidation && !line.suspendStartDateValidation) ? 'red' : ''}">{{authoringContentData?.manageLine?.endDate}}*</label>
                          <span class="box_icon date_iocn" (click)="d.toggle()"
                            [ngClass]="{'endDateClaenderDisable': !line.startDate}"></span>
                          <span class="far fa-calendar-alt "></span>
                        </div>
                        <div class="displayErrorInline pb-3" *ngIf="line.errorMsg && !line.endDate">
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div *ngIf="line.susEligibilityerroeInline" class="displayErrorInline">
                  <span>{{line.susEligibilityerroeInline}}</span>
                </div>
                <div class="row" *ngIf="line.isSeasonal" class="seasonaloption">
                  <span> {{authoringContentData?.bulkFlow?.seasonalInfoTxt}}</span>
                </div>
                <div class="row" *ngIf="line.isSeasonal" class="selectionMandatory">
                  <span>{{authoringContentData?.bulkFlow?.selectionTxt}} </span></div>

                <div class="mt-4 text-color" *ngIf="!applyToAll && line.reasonForChanges?.code === elstConstant">
                  {{authoringContentData?.manageLine?.lostStolenInfoTxt}}</div>

                <div class="row align-items-center h-100 mt-4">
                  <div class="col-12 col-md-4 mb-2">
                    <button type="button" class="col-12 primary_btn"
                      (click)="nextStep(line); expansionPanelClosed(line);"
                      [disabled]="!line.succesValidator">{{authoringContentData?.manageLine?.next}}
                    </button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
          </mat-accordion>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row col-12 pl-0">
        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.suspend">
            {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
          </button>
        </div>
        <div class="col-12 col-md-6 pl-0"
          *ngIf="linesWithErrorDuplicate?.length > 0 && (isRestoreFlow || isSimSwapFlow || isSuspendFlow )">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.suspend">{{authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems}}</button>
        </div>
        <div class="col-12 col-md-6 agre-line d-flex">
          <div>
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="acceptanceText pl-2">
            <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxt}}</span>
          </div>
        </div>
      </div>
      <div class="row col-12 pl-0 pt-3">
        <div class="col-12 pl-0">
            <p class="text-color ban-bulk-suspend">
              {{authoringContentData.bulkFlow.serviceDisconnectMsg}}
            </p>
            <p class="text-color ban-bulk-suspend">
              {{authoringContentData.bulkFlow.suspendTxt}}
            </p>
        </div>

      </div>
    </div>
  </div>
  <!-- Suspend block Ends-->

   <!-- Sim Swap block start-->
  <div *ngIf="isSimSwapFlow">
    <div class="modal-header hdr-bt-0">
      
      <h4 class="modal-title">{{blkUpldSubmittitle}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10" *ngIf="itemLoadedSuccfully">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithErrorDuplicate?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length >= 13">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>
        <div *ngIf="linesWithError.length < 13">
          <mat-accordion *ngFor="let sline of linesWithError; let i=index;">
            <mat-expansion-panel [expanded]="manageLineService.step === i">
              <mat-expansion-panel-header (click)="manageLineService.setStep(i)" class="specific-class">
                <mat-panel-title class="accordion-txt">
                  <span [ngClass]="(sline.success) ? 'succes_validator' : 'error_complete'"></span>
                  {{sline?.PhoneNumber}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <app-sim-change-form [msisdn]="sline.PhoneNumber" [oldSim]="sline.OldSim" [lineType]="true"
                (submitNextValue)='visibleNextButton($event)' [reasons]="reasons" [multiSimChange]="linesWithError" [bulkSuccesslines] ="restoreLines"
                [bulkSimChange]="true" [selectedReason]="sline.Reason_For_Change" [lineIndex]="i"></app-sim-change-form>
              <button (click)="manageLineService.nextStep(); expansionPanelClosed(sline);" type="button"
                class="btn primary_btn"
                [disabled]="!sline.success">{{authoringContentData?.changeSim?.nextTxt}}</button>
            </mat-expansion-panel>
            <br />
            <hr *ngIf="i !== (linesWithError.length - 1)" id="tmo-suspendMulti-horizontalLine_1"
              class="suspend-horizontalline">
          </mat-accordion>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row col-12 pl-0">
        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.simSwap">
            {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
          </button>
        </div>

        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length > 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.simSwap">{{authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems}}</button>
        </div>
        <div class="col-12 col-md-6 agre-line d-flex">
          <div>
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="acceptanceText pl-2">
            <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxt}}</span>
          </div>
        </div>
      </div>

      <div *ngIf="restoreErrorMsg" class="row col-12 pl-0">
        <span class="displayErrorInline">{{restoreErrorMsg}}</span>
      </div>
      <div class="row col-12 pl-0">
        <div class="col-12 pl-0">
          <p class="adverts">{{authoringContentData?.changeSim?.multipleRequestTxt}}</p>
          <p class="adverts">{{authoringContentData?.changeSim?.advertiseTxt}}</p>
          <br>
          <p class="advert-text"> {{authoringContentData?.changeSim?.serviceNoteTxt}}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Sim Swap block Ends-->

  <!-- Restore block start-->
  <div *ngIf="isRestoreFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkRestore}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{restoreLines.length}}
            {{authoringContentData?.bulkFlow?.itemsUploadedSuccessfullyText}}</span>
          </div>
          <div *ngIf="linesWithErrorDuplicate?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length >= 13">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>
        <div *ngIf="linesWithError.length < 13">
          <mat-accordion *ngFor="let line of linesWithError;let i = index">
            <mat-expansion-panel [expanded]="line.expendFlagValue" (closed)="expansionPanelClosed(line)"
              (opened)="expansionPanelOpened(line)">
              <mat-expansion-panel-header class="specific-class" (click)="manageLineService.setStep(i)">
                <mat-panel-title class="accordion-txt">
                  <span class="succes_validator" *ngIf="line.succesValidator"></span>
                  <span class="error_complete" *ngIf="line.errorValidator"></span>
                  {{line?.PhoneNumber}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="small-normal-black">
                <div class="row col-lg-6 col-sm-6 col-md-6 " id="temporary-end_date_div">
                  <div class="label_box mt-2">
                    <div class="date_label">
                      <div class="datepic_box">
                        <input type="text" class="datepicker" name="dp" placeholder="{{line?.placeholder}}"
                          [(ngModel)]="line.multiRestoreDate" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()"
                          (dateSelect)="multiplRestoreDateSelected(line)" [minDate]="minimumDate" [maxDate]="maxDate"
                          [ngClass]="{'storeDateClaenderDisable': line.startDate}" />
                        <label id="temporary-end_date_label start-date-position" class="floating-label"
                          [ngClass]="{'errorInline': (line.errorMsg && line.errorValidator)}">{{authoringContentData?.manageLineRestore?.restoreDateTxt}}</label>
                        <span class="box_icon date_iocn" (click)="d.toggle()"></span>
                        <span class="far fa-calendar-alt " (click)="d.toggle()"
                          (dateSelect)="multiplRestoreDateSelected(line)"></span>
                      </div>
                    </div>
                  </div>
                  <div class="errorInline" *ngIf="line.errorMsg && line.errorValidator">
                    {{line.errorMsg}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-4 mt-3">
                    <button type="button" class="col-12 primary_btn"
                      (click)="nextStep(line); expansionPanelClosed(line);"
                      [disabled]="line.errorValidator">{{authoringContentData?.manageLineRestore?.nextTxt}}</button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
          </mat-accordion>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row col-12 pl-0">
        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.restore">
            {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
          </button>
        </div>
        <div class="col-12 col-md-6 pl-0"
          *ngIf="linesWithErrorDuplicate?.length > 0 && (bulkFlow === restoreFlow || bulkFlow === simSwapFlow || bulkFlow === suspendFlow )">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox">{{authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems}}</button>
        </div>
        <div class="col-12 col-md-6 agre-line d-flex">
          <div>
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="acceptanceText pl-2">
            <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxt}}</span>
          </div>
        </div>
      </div>
      <div *ngIf="restoreErrorMsg" class="row col-12 pl-0 pt-3">
        <span class="displayErrorInline">{{restoreErrorMsg}}</span>
      </div>
      <div class="row col-12 pl-0 pt-3">
        <div class="col-12 pl-0">
          <p class="adverts">{{authoringContentData?.manageLineRestore?.bulkRestoreAdvertiseTxt}}</p>
          <br>
          <p class="advert-text"> {{authoringContentData?.manageLineRestore?.bulkRestoreAdvertiseMsgTxt}}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Restore block Ends-->

  <!-- Transfer Number block start-->
  <div *ngIf="isTransferNumberFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.bulkUploadTransferNumberTitleTxt}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeBulkNumberTransferXTag()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{transferNumberLines.length}}
              {{authoringContentData?.bulkFlow?.itemsUploadedSuccessfullyText}}</span>
          </div>
          <div>
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{tempLineWithError.length}} {{authoringContentData?.bulkFlow?.issuesFound}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length >= 13">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>
        <div *ngIf="linesWithError.length < 13">
          <mat-accordion *ngFor="let line of linesWithError; let i=index;">
            <mat-expansion-panel (afterExpand)="matPanelOpenCloseClickTag('Expand')" (closed)="matPanelOpenCloseClickTag('Collapse')" [expanded]="line.expendFlagValue">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="issueIcon"
                    *ngIf="(!line.isAccordionValidated) || (!line.tranNumber && !line.carrierNumber) || line.carrierNumber === ''"></span>
                  <span class="successIcon"
                    *ngIf="line.isAccordionValidated === true && line.tranNumber && line.carrierNumber"></span>
                  <span class="issueMisdn-txt">{{line['T-Mobile MSISDN'] | phone}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row clearfix m-b-10">
                <div class="col-6 m-b-35">
                  <div class="addGroupText">
                    <input type="text" appPhoneMask class="addGroup-input" maxlength="14" required=""
                      [(ngModel)]="line.tranNumber" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      (change)="validateTransferNumber(line)"
                      [ngClass]="{'error': (validateDuplicateTransferNumber(line) === true && isLengthValid(line) === true) || validateNumberToTransferSameAsMSISDN(line) === true || isLengthValid(line) === false}">
                    <div class="displayErrorInline"
                      *ngIf="validateDuplicateTransferNumber(line) === true && isLengthValid(line) === true">
                      {{authoringContentData?.transferNumberAuthoring?.duplicateNumberErrMsg}}</div>
                    <div class="displayErrorInline" *ngIf="validateNumberToTransferSameAsMSISDN(line) === true">
                      {{authoringContentData?.transferNumberAuthoring?.sameAsMSISDNErrMsg}}</div>
                    <div class="displayErrorInline" *ngIf="isLengthValid(line) === false">
                      {{authoringContentData?.transferNumberAuthoring?.errorMsgNumberTransfer}}</div>
                    <div class="displaySuccessInline"
                      *ngIf="isLengthValid(line) === true && validateNumberToTransferSameAsMSISDN(line) === false && validateDuplicateTransferNumber(line) === false">
                      {{authoringContentData?.transferNumberAuthoring?.validTransferNumber}}</div>
                    <span
                      class="floating-label">{{authoringContentData?.transferNumberAuthoring?.tnNumberPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-6 m-b-35"></div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-6 m-b-35">
                  <div class="addGroupText">
                    <input type="text" class="addGroup-input" maxlength="30" required=""
                      [(ngModel)]="line.carrierNumber" (change)="validateAccountNumber(line)"
                      [ngClass]="{'error':(!line.carrierNumber || line.carrierNumber === '') || line.carrierNumber.length > 30}" />
                    <div class="displayErrorInline" *ngIf="!line.carrierNumber || line.carrierNumber === ''">
                      {{authoringContentData?.transferNumberAuthoring?.missingCarrierNumberErrMsg}}</div>
                    <div class="displayErrorInline" *ngIf="line.carrierNumber.length > 30">
                      {{authoringContentData?.transferNumberAuthoring?.invalidCarrierNumberErrMsg}}</div>
                    <span
                      class="floating-label">{{authoringContentData?.transferNumberAuthoring?.carrierNumberPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-6 m-b-35"></div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-6 m-b-35">
                  <div class="addGroupText">
                    <input type="password" class="addGroup-input" minlength="1" maxlength="30" required="" #acPassPin
                      [(ngModel)]="line.accountPinPass" />
                    <span class="fa" [ngClass]="acPassPin.type === 'password' ? 'fa-eye-slash' : 'fa-eye' "
                      (click)="toggleText(acPassPin)"></span>
                    <span
                      class="floating-label">{{authoringContentData?.transferNumberAuthoring?.accountPinPasswordPlaceholder}}</span>
                  </div>
                </div>
                <div class="col-6 m-b-20 infoBlock">
                  <img src="/assets/tfb-acctmgmt/images/icons/information.svg" class="m-r-10" alt="Info">
                  <p>{{authoringContentData?.transferNumberAuthoring?.accountPinPasswordHelpText}}</p>
                </div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-6 m-b-35">
                  <div class="addGroupText">
                    <div class="date_label">
                      <div class="datepic_box" (click)="calendarClickTag()">
                        <input type="text" class="datepicker addGroup-input" readonly name="dp" ngbDatepicker
                          #d1="ngbDatepicker" [maxDate]="maximumTransferDate" [minDate]="minimumTransferDate"
                          (click)="d1.toggle()" [(ngModel)]="line.portDate" (change)="validatePortDate(line)"
                          (dateSelect)="transformPortDate(line, true)"
                          [ngClass]="{'error':line.isPortDateValid == false || line.missingPortDate == true || line.isPortDateInValidFormat === false}" />
                        <div class="displayErrorInline" *ngIf="line.isPortDateValid === false">
                          {{authoringContentData?.transferNumberAuthoring?.invalidPortDateErrMsg}}</div>
                        <div class="displayErrorInline" *ngIf="line.missingPortDate === true || !line.portDate">
                          {{authoringContentData?.transferNumberAuthoring?.missingPortDateErrMsg}}</div>
                        <div class="displayErrorInline" *ngIf="line.isPortDateInValidFormat === false">
                          {{authoringContentData?.transferNumberAuthoring?.invalidPortDateFormatErrMsg}}</div>
                        <span
                          class="helpTxt p-t-5">{{authoringContentData?.transferNumberAuthoring?.portDateHelpText}}</span>
                        <span
                          class="floating-label">{{authoringContentData?.transferNumberAuthoring?.portDatePlaceholder}}</span>
                        <span class="box_icon date_iocn" (click)="d1.toggle()"></span>
                        <span class="far fa-calendar-alt"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 m-b-20 infoBlock">
                  <img src="/assets/tfb-acctmgmt/images/icons/information.svg" class="m-r-10" alt="Info">
                  <p>{{authoringContentData?.transferNumberAuthoring?.portDateInfoMsg}}</p>
                </div>
              </div>

              <div class="row clearfix m-b-10">
                <div class="col-6">
                  <a class="remove_number_link"
                    (click)="removeTransferNumber(line)">{{authoringContentData?.transferNumberAuthoring?.removeNumberTxt}}</a>
                </div>
                <div class="col-6"></div>
              </div>

            </mat-expansion-panel>
            <hr />
          </mat-accordion>

          <div class="row">
            <div class="col-12 businessAdvisement">
              <h5>{{authoringContentData?.bulkFlow?.businessAdvisementsTitle}}</h5>
              <p class="mb-0" [innerHTML]="this.authoringContentData.transferNumberAuthoring.tnBusinessAdswriteUp"></p>
            </div>
          </div>

        </div>

      </div>
      <div class="row" *ngIf="linesWithError.length >= 13">
        <div class="col-12 businessAdvisement">
          <h5>{{authoringContentData?.bulkFlow?.businessAdvisementsTitle}}</h5>
          <p class="mb-0" [innerHTML]="this.authoringContentData.transferNumberAuthoring.tnBusinessAdswriteUp"></p>
        </div>
      </div>

    </div>
    <hr class="mt-0">
    <div class="modal-footer">
      <div class="d-flex flex-column justify-content-center flex-md-row justify-content-md-end">
        <button type="button" class="secondary_btn m-r-10 m-b-10"
          (click)="cancelBulkNumberTransfer()">{{authoringContentData?.transferNumberAuthoring?.cancelTxt}}</button>
        <button type="button" class="primary_btn m-b-10" [disabled]="transferNumberLines.length == 0 ||  isReadOnlyForOkta.portIn"
          (click)="submitTransferNumberRequest()">{{tempLineWithError.length > 0 ? authoringContentData?.transferNumberAuthoring?.submitSuccessfulItemTxt : authoringContentData?.transferNumberAuthoring?.submitTxt}}</button>
      </div>
    </div>

  </div>
  <!-- Transfer Number block Ends-->

  <!-- Line Identifier block start-->
  <div *ngIf="isLineIdentifierFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title" *ngIf="!isUDFDormancyEnabled">{{authoringContentData?.bulkFlow?.bulkUploadLineIdentifierTitleTxt}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10" [ngClass]="{'responseMsgIconUDF':isUDFDormancyEnabled, 'responseMsgIcon' : !isUDFDormancyEnabled}" alt="Uploaded successfully">
            <span [ngClass]="{'udf-span-design' : isUDFDormancyEnabled}">{{validLineIdentifierLines.length}}
              {{authoringContentData?.bulkFlow?.itemsLoadedSucessTxt}}</span>
          </div>
          <div *ngIf="linesWithError.length>0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{linesWithError.length}} {{authoringContentData?.bulkFlow?.issuesFound}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length >= 13">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr *ngIf="enableCupNoRegrets" id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
        <div><strong>{{authoringContentData?.lineIdentifierAuthoring?.advisementsText}}</strong></div>
        <div *ngIf="isUDFDormancyEnabled">
          <div class="mt-4 text-color-advisements-udf" *ngIf="enableCupNoRegrets">{{authoringContentData?.lineIdentifierAuthoring?.udfAdvisementTextLineOne}}</div>
          <div class="mt-4 text-color-advisements-udf" *ngIf="enableCupNoRegrets">{{authoringContentData?.bulkFlow?.udfAdvisementTextLineOne}} <span>{{authoringContentData?.globalSidenavAuthoring?.transactionsLink}}.</span> {{authoringContentData?.bulkFlow?.udfAdvisementTextLineTwo}}</div>
        </div>
        <div *ngIf="!isUDFDormancyEnabled">
          <div class="mt-4 text-color-advisements" *ngIf="enableCupNoRegrets">{{authoringContentData?.lineIdentifierAuthoring?.advisementTextLineOne}}</div>
        <div class="mt-4 text-color-advisements" *ngIf="enableCupNoRegrets">{{authoringContentData?.bulkFlow?.advisementTextLineOne}} <span class="magenta">{{authoringContentData?.globalSidenavAuthoring?.transactionsLink}}</span> {{authoringContentData?.bulkFlow?.advisementTextLineTwo}}</div>
        </div>
      </div>
    </div>
  
    <div class="modal-footer">
      <div class="row col-12 pr-0">
        <div class="col-12 col-md-6 pr-0">
        </div>
        <div class="col-12 col-md-6 pr-0">
          <button type="button" class="col-12 primary_btn floatRight" [ngClass]="{'popup-btn-class-udf': isUDFDormancyEnabled}" [disabled]="isReadOnlyForOkta.lineIdentifier" (click)="submitButtonClicked()">
             {{authoringContentData?.bulkFlow?.submitchangesCTA}} 
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Line Identifier block Ends-->

   <!-- Cancel Subscriber block start-->
   <div *ngIf="isCancelSubscriberFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkCancelSubscriber}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithError?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length !== 0">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>

      </div>
    </div>
    <div class="modal-footer">
      <div class="row col-12 pl-0">
        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox">
            {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
          </button>
        </div>
        <div class="col-12 col-md-6 pl-0"
          *ngIf="linesWithErrorDuplicate?.length > 0 && (isRestoreFlow || isSimSwapFlow || isSuspendFlow )">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.suspend">{{authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems}}</button>
        </div>
        <div class="col-12 col-md-6 agre-line d-flex">
          <div>
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="acceptanceText pl-2">
            <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxtForBulk}}</span>
          </div>
        </div>
      </div>
      <div class="row col-12 pl-0 pt-3">
        <div class="col-12 pl-0">
          <p class="text-color ban-bulk-suspend">
            {{authoringContentData?.cancelService?.advisements1}}
            {{authoringContentData?.cancelService?.advisements2}}
            {{authoringContentData?.cancelService?.advisements3}}
            {{authoringContentData?.cancelService?.advisements4}}
          </p>
        </div>

      </div>
    </div>
  </div>
  <!-- Cancel Subscriber block Ends-->
  <!-- Change Service block start-->
  <div *ngIf="isChangeServiceFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkChangeService}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithError?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
          <div class="success-issues-download">
            <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
            <div *ngIf="linesWithError.length !== 0">
              <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
                <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
                {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
              </a>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row col-12 pl-0">
          <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
            <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
              [disabled]="!selectsubmitCheckBox">
              {{bulkUploadFailedFlag ?   authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems : authoringContentData?.changeNumberAuthoring?.submitChange }}
            </button>
          </div>
          <div class="col-12 col-md-6 pl-0"
            *ngIf="linesWithErrorDuplicate?.length > 0 && (isRestoreFlow || isSimSwapFlow || isSuspendFlow )">
            <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
              [disabled]="!selectsubmitCheckBox || isReadOnlyForOkta.suspend">{{authoringContentData?.changeNumberAuthoring?.submitSuccessfulItems}}</button>
          </div>
          <div *ngIf="!isSpectrumBarterBan" class="col-12 col-md-6 agre-line d-flex">
            <div>
              <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
            </div>
            <div class="acceptanceText pl-2">
              <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxt}}</span>
            </div>
          </div>
        </div>
        <div class="row col-12 pl-0 pt-3">
          <div id="termsConditions">
            <a> {{ authoringContentData?.changeService?.bulkChangeServiceWaitTimeMsg }}</a>
            <div *ngIf="!isSpectrumBarterBan">
            <br><br>
            {{authoringContentData?.reviewChangeService?.agreeAndSubmitMsg}}
            <a class="service_agreement" tabindex="0" href="javascript:void(0)" (click)="ServiceAgreement('cancelSubscriber')">
                <span class="link_color">{{authoringContentData?.reviewChangeService?.serviceAgreementTxt}}</span>
            </a>{{authoringContentData?.reviewChangeService?.termsSpecificMsg}}
            <a class="terms_conditions" tabindex="0" target="_blank" href="{{authoringContentData?.footer?.termsAndConditionUrl}}" rel="noopener" >
                <span class="link_color">{{authoringContentData?.reviewChangeService?.termsAndConditionText}}</span>
            </a>{{authoringContentData?.reviewChangeService?.termsMessageText}}
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Change Service block Ends-->


   <!-- Manage Pairing block start-->
   <div *ngIf="isManagePairingFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkManagePairing}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="success-issues-block">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithError?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download">
          <p *ngIf="linesWithError.length !== 0">{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div *ngIf="linesWithError.length !== 0">
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>
        <hr>

      </div>
    </div>
    <div class="modal-footer">
      <div class="row col-12 pl-0">
        <div class="col-12 col-md-6 pl-0" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox">
            {{ authoringContentData?.managePairing?.submitPairingBtn }}
          </button>
        </div>
        <div class="col-12 col-md-6 agre-line d-flex">
          <div>
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="acceptanceText pl-2">
            <span class="text-color">{{authoringContentData.bulkFlow.tncAgreeTxtForBulk}}</span>
          </div>
        </div>
      </div>
      <div class="row col-12 pl-0 pt-3">
        <div class="col-12 pl-0">
          <p class="text-color ban-bulk-suspend">
            {{ authoringContentData?.managePairing?.advisementMsg }}
          </p>
        </div>

      </div>
    </div>
  </div>
  <!-- Manage Pairing block Ends-->


   <!-- Strategic Port In block start-->
   <div *ngIf="isStrategicPortInFlow">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.bulkFlow?.headingBulkStrategicPortIn}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body body-color">
      <div class="success-issues-block st-portin-body-height">
        <div class="success-issues-report">
          <div class="m-b-10">
            <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
            <span>{{itemLoadedSuccfully}}</span>
          </div>
          <div *ngIf="linesWithError?.length > 0">
            <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
            <span>{{itmeNotLoadeSuccefully}}</span>
          </div>
        </div>
        <div class="success-issues-download" *ngIf="linesWithError.length !== 0">
          <p>{{authoringContentData?.bulkFlow?.reviewStatement}}</p>
          <div >
            <a href="javascript:void(0)" (click)="downloadErrorSpreadheet()">
              <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" alt="Download full spreadsheet with errors">
              {{authoringContentData?.bulkFlow?.downloadSpreadsheetWithError}}
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer modal-footer-st-portin">
      <div class="st-portin-body">
        {{authoringContentData?.bulkFlow?.bodyBulkStrategicPortIn}}
        <hr class="hr-margin">
      </div>
     
      <div class="row">
        <div class="col-12 st-portin-foo">
          <span class="advisement-font">{{authoringContentData?.changeNumberAuthoring?.advisementsTxt}}</span>
          <p class="mb-0">{{this.authoringContentData.bulkFlow.bulkStrategicPortInFooter1}}
          <a href="javascript:void(0)" (click)="goToTransactions()" class="link_color link-font">
             {{this.authoringContentData.bulkFlow.bulkStrategicPortInFooter2}}</a>
          {{this.authoringContentData.bulkFlow.bulkStrategicPortInFooter3}}</p> <br>
          <p>{{this.authoringContentData.bulkFlow.bulkStrategicPortInFooter4}}</p>
          <p>{{this.authoringContentData.bulkFlow.bulkStrategicPortInFooter5}}</p>
        </div>
      </div>
      <div class="row col-12 pl-0 p-r-0">
        
        <div class="col-6 col-md-6 agre-line d-flex">        
          <div class="p-r-2">
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="termsAndConditionCheckBox"></mat-checkbox>
          </div>
          <div class="st-portin-foo footer-padding">{{authoringContentData.bulkFlow.bulkStrategicPortInTerms}}
              <a  target="_blank" href="{{authoringContentData?.changeRatePlan.ratePlanTermsAndConditionApiUrl}}" rel="noopener" class="link_color link-font">
                {{this.authoringContentData.bulkFlow.bulkStrategicPortInTermsLink}}</a>.
          </div>
        </div>

        <div class="col-2 col-md-2 pl-0 submit-padding" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 cancel_btn" (click)="manageLineService.close()">
            {{ authoringContentData?.changeNumberAuthoring?.individualAlertModalCancelBtn }}
          </button>
        </div>

        <div class="col-4 col-md-4 submit-padding" *ngIf="linesWithErrorDuplicate?.length === 0">
          <button type="button" class="col-12 primary_btn" (click)="submitButtonClicked()"
            [disabled]="!selectsubmitCheckBox">
            {{ authoringContentData?.bulkFlow?.submitchangesCTA }}
          </button>
        </div>

      </div>
    </div>
  </div>
  <!-- Strategic Port In block Ends-->
</div>